import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { GET_MARKET, DELETE_MARKET, UPDATE_MARKET, ADD_NEW_MARKET } from "./actionType";

import {
  getMarketSuccess,
  getMarketFail,
  deleteMarketSuccess,
  deleteMarketFail,
  updateMarketSuccess,
  updateMarketFail,
  addMarketSuccess,
  addMarketFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveMarketApi,
  getMarketApi,
  updateMarketApi,
  deleteMarketApi,
  addNewMarketApi,
} from "../../helpers/backend_helper";

function* getMarket({ payload: market }) {
  try {
    const response = yield call(getMarketApi, market);
    yield put(getMarketSuccess(GET_MARKET, response.data));
  } catch (error) {
    yield put(getMarketFail(GET_MARKET, error));
  }
}

function* onUpdateMarket({ payload: market }) {
  try {
    if (market.setApprove) {
      const response = yield call(approveMarketApi, market);
      yield put(updateMarketSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateMarketApi, market);
      yield put(updateMarketSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateMarketFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteMarket({ payload: market }) {
  try {
    const response = yield call(deleteMarketApi, market);
    yield put(deleteMarketSuccess({ market, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteMarketFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewMarket({ payload: market }) {
  try {
    const response = yield call(addNewMarketApi, market);
    yield put(addMarketSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addMarketFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetMarket() {
  yield takeEvery(GET_MARKET, getMarket);
}

export function* watchUpdateMarket() {
  yield takeEvery(UPDATE_MARKET, onUpdateMarket);
}

export function* watchDeleteMarket() {
  yield takeEvery(DELETE_MARKET, onDeleteMarket);
}

export function* watchAddNewMarket() {
  yield takeEvery(ADD_NEW_MARKET, onAddNewMarket);
}

function* marketSaga() {
  yield all([
    fork(watchGetMarket),
    fork(watchDeleteMarket),
    fork(watchUpdateMarket),
    fork(watchAddNewMarket),
  ]);
}

export default marketSaga;
